<template>
  <v-card class="mb-6">
    <WeeklyActivity :team="team" />

    <v-divider />

    <Activity :team="team" />
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

import mixin from '@/mixins/mixin.vue'

import WeeklyActivity from './WeeklyActivity/WeeklyActivity.vue'
import Activity from './Activity/Activity.vue'

const TABS_OPTIONS = {
  summary: 'summary',
  routines: 'routines',
  revs: 'revs',
  findings: 'findings',
}

export default {
  name: 'TeamActivity',

  mixins: [mixin],

  components: {
    WeeklyActivity,
    Activity,
  },

  props: {
    team: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      activeTab: TABS_OPTIONS.summary,
      TABS_OPTIONS,
    }
  },

  computed: {
    ...mapGetters(['organizationId']),
  },

  methods: {
    selectSummaryTab() {
      this.activeTab = TABS_OPTIONS.summary
    },

    selectRoutinesTab() {
      this.activeTab = TABS_OPTIONS.routines
    },

    selectFindingsTab() {
      this.activeTab = TABS_OPTIONS.findings
    },

    selectRevsTab() {
      this.activeTab = TABS_OPTIONS.revs
    },
  },
}
</script>
